import PropTypes from 'prop-types'
import { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Button, Form, Message, Modal } from 'semantic-ui-react'

import { trackEvent } from 'global-utils/Analytics'

import { authAction, authLoginByCredentials, authLoginCanceled } from 'actions/AuthActions'
import cloneDeep from 'lodash/cloneDeep'

import './Login.css'

class Login extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      email: '',
      pass: '',
      totalDirties: 2,
      updating: false,
    }
    this.errors = {}
    this.dirties = {}
    this.updatingTimeout = null
  }

  componentDidUpdate(prevProps) {
    if (this.state.updating && prevProps.error !== this.props.error) {
      this.startUpdateTimeout()
    }
  }

  componentWillUnmount() {
    clearTimeout(this.updatingTimeout)
  }

  close = () => {
    this.props.authLoginCanceled()
    this.props.onClose()
  }

  onChange = (field, event) => {
    const newState = cloneDeep(this.state)
    let value = (event.target.value || '').trim()
    let error = false
    const errorField = field

    switch (field) {
      case 'email': {
        const re =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        error = !value || value.length <= 1 || !re.test(value)
        break
      }
      case 'pass': {
        value = event.target.value || ''
        error = !value || value.length <= 5
        break
      }
      default: {
        break
      }
    }

    newState[field] = value
    this.dirties[field] = true

    if (error) {
      this.errors[errorField] = true
    } else {
      delete this.errors[errorField]
    }

    this.setState(newState)
  }

  onFormSubmit = (event) => {
    trackEvent('Authentication', 'Login', 'Attempt')
    event.preventDefault()
    const hasErrors = Object.keys(this.errors).length
    const totalDirties = Object.keys(this.dirties).length
    if (!this.state.updating && !hasErrors && totalDirties === this.state.totalDirties) {
      this.setState({
        updating: true,
      })
      this.props.authLoginByCredentials(this.state.email, this.state.pass)
    }
  }

  onPasswordResetClick = (event) => {
    event.preventDefault()
    this.props.authAction('reset')
  }

  onRegisterClick = (event) => {
    event.preventDefault()
    this.props.authAction('register')
  }

  startUpdateTimeout = () => {
    clearTimeout(this.updatingTimeout)
    this.updatingTimeout = setTimeout(() => this.setState({ updating: false }), 1000 * 7)
  }

  render() {
    const { error, open } = this.props
    const { updating } = this.state
    const errorMsg = error ? <Message content={error.msg} error header="Error" /> : ''
    const hasErrors = Object.keys(this.errors).length > 0
    return (
      <Modal className="ModalLogin" closeIcon="close" onClose={this.close} open={open} size="small">
        <Modal.Header>Ingresa a SweatBits</Modal.Header>
        <Modal.Content>
          <Form key="mini" as="form" error={!!error || hasErrors} onSubmit={this.onFormSubmit} size="mini">
            <Form.Field
              autoComplete="email"
              control="input"
              error={!!this.errors.email}
              label="E-mail"
              onChange={(e) => this.onChange('email', e)}
              placeholder="E-mail"
              type="email"
            />
            <Form.Field
              autoComplete="current-password"
              control="input"
              error={!!this.errors.pass}
              label="Contraseña"
              onChange={(e) => this.onChange('pass', e)}
              placeholder="Contraseña 6+"
              type="password"
            />
            <Button
              className={`ModalLogin__button ${updating ? 'loading disabled' : 'primary'} ${
                Object.keys(this.dirties).length === this.state.totalDirties ? '' : ' disabled'
              }`}
              type="submit"
            >
              Ingresar
            </Button>
            <div className="flex justify-between text-green">
              <a className="py-2" href="/" onClick={this.onPasswordResetClick}>
                Olvidé mi contraseña
              </a>
              <a className="py-2" href="/" onClick={this.onRegisterClick}>
                Registrarme
              </a>
            </div>
            {errorMsg}
          </Form>
        </Modal.Content>
      </Modal>
    )
  }
}

Login.propTypes = {
  authAction: PropTypes.func.isRequired,
  authLoginByCredentials: PropTypes.func.isRequired,
  authLoginCanceled: PropTypes.func.isRequired,

  error: PropTypes.object,
  onClose: PropTypes.func,
  open: PropTypes.bool,
}

Login.defaultProps = {
  error: null,
  onClose: Function.prototype,
  open: false,
}

export default connect(({ auth: { error } }) => ({ error }), {
  authAction,
  authLoginByCredentials,
  authLoginCanceled,
})(Login)
